// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 960px) {
  .featured-collection-slider__meta.show-mobile-arrows .featured-collection-slider__navigation-buttons.visible {
    position: absolute;
    right: 0;
    top: 40%;
    left: 0;
    margin-right: 10px;
    margin-left: 10px;
    display: flex;
    flex: 1;
    justify-content: space-between;
  }
  .featured-collection-slider__meta.show-mobile-arrows .featured-collection-slider__navigation-buttons.visible .carousel__navigation-button {
    z-index: 1000;
  }
}
.product-item .product-item__meta .product-item__add-to-cart-on-mobile {
  display: var(--add-to-cart-on-mobile-display, none);
}

@media (min-width: 960px) {
  .product-item .product-item__meta .product-item__add-to-cart-on-mobile {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/styles/featured-collection-slider.scss"],"names":[],"mappings":"AAAA;EAGM;IACE,kBAAA;IACA,QAAA;IACA,QAAA;IACA,OAAA;IACA,kBAAA;IACA,iBAAA;IACA,aAAA;IACA,OAAA;IACA,8BAAA;EADN;EAGM;IACE,aAAA;EADR;AACF;AASI;EACE,mDAAA;AAPN;;AAYA;EAGM;IACE,aAAA;EAXN;AACF","sourcesContent":["@media (max-width: 960px) {\n  .featured-collection-slider__meta {\n    &.show-mobile-arrows {\n      .featured-collection-slider__navigation-buttons.visible {\n        position: absolute;\n        right: 0;\n        top: 40%;\n        left: 0;\n        margin-right: 10px;\n        margin-left: 10px;\n        display: flex;\n        flex: 1;\n        justify-content: space-between;\n\n        .carousel__navigation-button {\n          z-index: 1000;\n        }\n      }\n    }\n  }\n}\n\n.product-item {\n  .product-item__meta {\n    .product-item__add-to-cart-on-mobile {\n      display: var(--add-to-cart-on-mobile-display, none);\n    }\n  }\n}\n\n@media (min-width: 960px) {\n  .product-item {\n    .product-item__meta {\n      .product-item__add-to-cart-on-mobile {\n        display: none;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
